export const uploadDagStatus = {
  UNKNOWN: { label: '-', val: 0 },
  PENDING: { label: 'Pending', val: 1 },
  SUCCESS: { label: 'Success', val: 2 },
  FAILED: { label: 'Failed', val: 3 },
};
